var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewResponseIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 18",
    width: 21,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 21,
    height: 18,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAASCAMAAACDzGUcAAAAAXNSR0IB2cksfwAAATVQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////FYcbswAAAGd0Uk5TAByb9Pz6+7s2Fsrwl36AiNnrOH3/UCXhvcsHqOiymSIOcezasfHdaANJxv3VvMA6tjUZ+EKd4sMGgxgIYYsR5cQPIZjRVTm0njzMyO/qYwl4oRC/DJrnrdsSs1KUCmqO49zeBF96FSnV3QMAAADeSURBVHicXc55VwFhFMfxn8k0mGR7mGSKRIQZoYRRtpCthRYN7Xj/L6E5J84zM98/P/ecey9gYbasLG2b5WyA3cHvOHdpTpfb44WP+GEsIOyBC+6bFCERB+xh2GCRo+gxYnFykkhSPE2l+QwkOXuW5nJryzMF4fyiCOmyhIRAyhXNlKrIX12DqUGqN4Bmi9y00emSblYb3q4V6PWtg+HoToFBcf8gPub/l+sUGG/eMCh0OpGfzPr8gtfpm1nVImZkblHeaUrjo/CJZJl8feua/rCqdul3ocoTmiwtV/gDcqUr8M1AkPQAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewResponseIcon3);
export default __webpack_public_path__ + "static/media/reviewResponseIcon3.6817af1444e330a9cbc4d8a08c576c81.svg";
export { ForwardRef as ReactComponent };